










/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import LayerConfig from '@/models/map-context/LayerConfig';
import { EVENTS } from '@/services/EventBus';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

@Component<LayerLegendImage>({
  props: {
    layer: LayerConfig,
  },
  watch: {
    layer() {
      this.refresh();
    },
    'layer.styleRefreshToken'() {
      this.refresh();
    },
    'layer.selectedStyle'() {
      this.refresh();
    },
    'layer.useSldBody'() {
      this.refresh();
    },
  },
})
export default class LayerLegendImage extends BaseComponent {
  layer!: LayerConfig;

  legendUrl = '';

  mounted() {
    this.refresh();
    this.getEventBus().$on(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  beforeDestroy() {
    this.getEventBus().$off(EVENTS.LAYER_UPDATED, this.onLayerUpdated);
  }

  onLayerUpdated = (layer: LayerConfig) => {
    if (layer && this.layer && (layer === this.layer || layer.uid === this.layer.uid)) {
      this.refresh();
    }
  }

  refresh() {
    const legendUrl = this.layer.getLegendImageUrl();
    const maxUrlLength = 2000;
    if (legendUrl.length < maxUrlLength) {
      const separator = legendUrl.indexOf('?') >= 0 ? '&' : '?';
      const token = this.layer.styleRefreshToken || 0;
      this.legendUrl = `${legendUrl}${separator}_t=${token}`;
      return;
    }
    const client = new XMLHttpRequest();
    const urlArray = legendUrl.split('?');
    const url = urlArray[0];
    const params = urlArray[1];
    client.open('POST', url, true);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    client.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    client.setRequestHeader('X-CSRFToken', this.contextService.getCsrfToken());
    client.responseType = 'arraybuffer';

    client.onload = function onload() {
      const arrayBufferView = new Uint8Array(this.response);
      const blob = new Blob([arrayBufferView], { type: 'image/png' });
      const urlCreator = window.URL || (window as any).webkitURL;
      const imageUrl = urlCreator.createObjectURL(blob);
      self.legendUrl = imageUrl;
    };
    client.addEventListener('error', () => {
      console.log('erreur');
    });
    client.send(params);
  }
}
